<template>
  <health-report-exam-enter
    :title="title"
    :format="format"
    ref="examEnter"
    :disabled="disabled"
  ></health-report-exam-enter>
</template>
<script>
import HealthReportExamEnter from "./HealthReportExamEnter";
export default {
  extends: HealthReportExamEnter,
  components: { HealthReportExamEnter },
  data: () => ({
    examData: {}
  }),
  computed: {
    test() {
      let test = this.examData.ALB / this.examData.GLOB;
      if (!isNaN(test) && isFinite(test)) {
        return test.toFixed(2);
      } else {
        return "";
      }
    }
  },
  watch: {
    test(val) {
      this.examData.AG = val;
    }
  },
  methods: {
    setExamData(data) {
      this.$refs.examEnter.setExamData(data);
      this.examData = data;
    },
    setPreviousData(previous) {
      this.$refs.examEnter.setPreviousData(previous);
    },
    getExamData() {
      return this.$refs.examEnter.getExamData();
    }
  }
};
</script>
